// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__vhu3Y","ackoLogo":"header_ackoLogo__X2gPd"};